import { supabase } from "@/integrations/supabase/client";
import { consumeRedirectIntent, getRedirectIntent } from "@/lib/redirect-intent";
import { resolvePostAuthDestination, type OnboardingState } from "@/lib/post-auth";
import { meetProfileReady, OPT_OUT_STATUS } from "@/lib/onboarding-steps";

export const onboardingStateKey = (userId: string) => ["onboarding-state", userId] as const;

/** Лёгкий запрос: только поля, нужные замку и выбору пути после входа. */
export async function fetchOnboardingState(userId: string): Promise<OnboardingState | null> {
  const { data, error } = await supabase
    .from("profiles")
    .select("onboarding_gate, onboarding_completed_at, profession, coffee_status, telegram, social_links")
    .eq("user_id", userId)
    .maybeSingle();
  if (error) throw error;
  if (!data) return null;
  const meetStatus = (data.coffee_status ?? []).filter(Boolean);
  return {
    onboarding_gate: data.onboarding_gate,
    onboarding_completed_at: data.onboarding_completed_at,
    meet_ready: meetProfileReady({
      profession: data.profession ?? "",
      meetStatus,
      hasContact: !!data.telegram?.trim() || (data.social_links ?? []).some((s) => !!s?.trim()),
      optOut: meetStatus.includes(OPT_OUT_STATUS),
    }),
  };
}

/** Путь после входа; при ошибке сети не блокируем — обычный путь. */
export async function postAuthDestination(userId: string): Promise<string> {
  let state: OnboardingState | null = null;
  try {
    state = await fetchOnboardingState(userId);
  } catch {
    state = null;
  }
  return resolvePostAuthDestination(state, consumeRedirectIntent, getRedirectIntent);
}
